export default __webpack_public_path__ + "static/media/contactme2.60b554e7.png";